const env = require('./env.js');

// Experimental support for all browsers
export default () => env.isChromium || env.isFirefox || env.isSafari;
